import { Box, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { useCallback, useEffect, useState } from 'react'
import CommonGridHeader, { CommonDeleteButton, CommonEditButton, DeletePopup } from '../../../Components/Common Components/CommonComponents';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../Styles/Colors';
import '../Configuration.css';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';

const TPAMasters = (props) => {
    const [state, setState] = useState({
        page: 0,
        pageSize: 10,
        tpaData: [],
        deletePopup: false,
        rowValue: null,
        selectedId: null,
        tpaName: '',
        branch_ID: localGetItem("BranchId"),
        isEdit: false,
        isLoader: false,
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: ''
    });

    useEffect(() => {
        getTPAData();
    }, []);

    const updateState = (newValue) => {
        setState(prevState => ({ ...prevState, ...newValue }));
    };

    const errorMessage = (message) => {
        updateState({ isErrorMsg: true, isErrorMsgText: message });
    };

    const successMessage = (message) => {
        updateState({ successMsg: true, successMsgText: message });
    };

    const loaderFunction = (key) => {
        updateState({ isLoader: key });
    };

    const getTPAData = useCallback(() => {
        try {
            loaderFunction(true);
            RestAPIService.getAll(`${Serviceurls.FO_TPA_MASTER_LIST}?branch_id=${parseInt(state.branch_ID)}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        const filteredData = response.data.data.filter(item => item.is_active === true);
                        const dataWithSno = filteredData.map((item, index) => ({ ...item, sno: index + 1 }));
                        updateState({ tpaData: dataWithSno, isLoader: false });
                    }
                })
                .catch((error) => {
                    loaderFunction(false);
                    const msg = error?.response?.data?.status === "fail" ? error.response.data.message : error.message;
                    errorMessage(msg);
                });
        } catch (error) {
            loaderFunction(false);
            errorMessage(error.message);
        }
    }, [state.branch_ID]);

    const onEditHandler = (value) => {
        try {
            updateState({
                isEdit: true,
                tpaName: value?.row?.tpa_name || '',
                selectedId: value?.row?.id,
            });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const onDeleteHandler = (value) => {
        if (!state.isEdit) {
            updateState({
                deletePopup: true,
                rowValue: value?.row,
                selectedId: value?.row?.id,
                DeletedtpaName: value?.row?.tpa_name || '',
            });
        } else {
            errorMessage("You have clicked edit Button. So, you cannot delete.");
        }
    };

    const onClearHandler = () => {
        updateState({
            tpaName: '',
            selectedId: null,
            isEdit: false,
            deletePopup: false,
            rowValue: null
        });
    };

    const postTPAData = (isDelete = false) => {
        try {
            if (!(state.tpaName).trim() && !isDelete) {
                errorMessage("Please Enter TPA Name");
                return;
            }

            let data = {
                "tpa_name": isDelete ? state.DeletedtpaName : state.tpaName.trim() || '',
                "is_active": isDelete ? false : true,
                "branch_id": +state.branch_ID
            };

            if (state.isEdit || isDelete) {
                data['id'] = state.selectedId;
            }

            const RESTAPI = (state.isEdit || isDelete)
                ? RestAPIService.updateWithOutId(data, Serviceurls.FO_TPA_MASTER_LIST)
                : RestAPIService.create(data, Serviceurls.FO_TPA_MASTER_LIST);

            loaderFunction(true);
            RESTAPI.then((response) => {
                if (response.data.status === 'success') {
                    onClearHandler();
                    getTPAData();
                    successMessage(response?.data?.message);
                }
            }).catch((error) => {
                loaderFunction(false);
                const msg = error?.response?.data?.status === "fail" ? error.response.data.message : error.message;
                errorMessage(msg);
            });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        });
    };

    const columns = [
        { field: "sno", sortable: false, flex: 0.10, headerName: "SNo" },
        {
            field: "tpa_name", flex: 0.75, headerName: "TPA Name", type: 'string', sortable: false, hideable: false,
            renderCell: (params) => (<Box component={'div'}>{params?.row?.tpa_name || '-'}</Box>)
        },
        {
            field: "action", flex: 0.15, headerName: "Action", headerAlign: 'center', align: 'center', sortable: false, hideable: false,
            renderCell: (params) => (
                <div>
                    <CommonEditButton
                        disable={!CheckAccessFunc("front_office", "Settings", "Insurance Configuration", "TPA Master", "SubTab")?.editAccess}
                        size={"1.5vw"}
                        onClick={() => onEditHandler(params)}
                    />
                    <CommonDeleteButton
                        disable={!CheckAccessFunc("front_office", "Settings", "Insurance Configuration", "TPA Master", "SubTab")?.editAccess}
                        size={"1.5vw"}
                        onClick={() => onDeleteHandler(params)}
                    />
                </div>
            )
        }
    ];

    return (
        <Box component={"div"} className='eMed_refdoc_container'>
            <Grid container spacing={2} className='eMed_refdoc_content'>
                <Grid item xs={8}>
                    <Stack component={"div"}>
                        <Paper className='eMed_refdoc_left'>
                            <DataGrid
                                rows={state.tpaData}
                                columns={columns}
                                getRowId={(row) => row['id']}
                                page={state.page}
                                pageSize={state.pageSize}
                                localeText={{
                                    toolbarColumns: "",
                                    toolbarDensity: "",
                                    toolbarExport: "",
                                    toolbarFilters: "",
                                    toolbarExportPrint: ""
                                }}
                                disableSelectionOnClick
                                components={{
                                    Toolbar: CommonGridHeader.CommonToolBar,
                                    NoRowsOverlay: () => (
                                        <Stack className='eMed_conf_nodata'>{"No Records Found"}</Stack>
                                    )
                                }}
                                onPageChange={(newPage) => updateState({ page: newPage })}
                                onPageSizeChange={(newPageSize) => updateState({ pageSize: newPageSize })}
                                rowsPerPageOptions={[10, 20, 30]}
                                pagination
                                loading={state.isLoader}
                            />
                        </Paper>
                    </Stack>
                </Grid>

                <Grid item xs={4}>
                    <Paper className='eMed_refdoc_right' elevation={1}>
                        <Typography className='eMed_refdoc_title'><strong>{"TPA Configuration"}</strong></Typography>
                        <Box component={'div'} height={"57.8vh"}>
                            <Grid container className='eMed_refdoc_txt_card'>
                                <TextField
                                    autoComplete='off'
                                    label="TPA Name"
                                    size="small"
                                    sx={{ width: '28vw' }}
                                    value={state.tpaName}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 50) {
                                            updateState({ tpaName: e.target.value });
                                        }
                                    }}
                                />
                            </Grid>
                        </Box>
                        <Stack spacing={2} direction="row" className='eMed_ref_btn' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                            <Button variant='outlined' size="small" onClick={onClearHandler}>{"Clear"}</Button>
                            <Button
                                variant='contained'
                                size="small"
                                disabled={!CheckAccessFunc("front_office", "Settings", "Insurance Configuration", "TPA Master", "SubTab")?.editAccess}
                                onClick={() => postTPAData(false)}
                            >
                                {state.isEdit ? "Update" : "Add"}
                            </Button>
                        </Stack>
                    </Paper>
                </Grid>
            </Grid>

            {state.deletePopup && (
                <DeletePopup
                    DeletTitle={`${"Are you sure you want to delete"} ${state.rowValue?.tpa_name || "-"} ?`}
                    deleteAlertPopupClose={() => updateState({ deletePopup: false })}
                    removeData={() => postTPAData(true)}
                    DeleteNotify={"If you remove this, this could be effect in entire Configurations"}
                />
            )}
            {state.isErrorMsg && <ToastMsg severity='error' msg={state.isErrorMsgText} msgPop={msgClose} />}
            {state.successMsg && <ToastMsg severity='success' msg={state.successMsgText} msgPop={msgClose} />}
        </Box>
    );
};

export default TPAMasters;